import { Create } from 'react-admin';
import { UserForm } from './User.Form';

export const UserCreate = () => (
    <Create redirect="list">
        <UserForm />
    </Create>
);
